/*
 * @Author: 汪永康 wangyongkang@yxj.org.cn
 * @Date: 2024-08-23 14:49:55
 * @LastEditors: 汪永康 wangyongkang@yxj.org.cn
 * @LastEditTime: 2024-11-20 16:15:44
 * @FilePath: \h5-lcjc-formula\src\utils\category\Card.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/** 心血管病学 */

/** 对应的标题 */
const categoryMap = {
  Killip: 'Killip 分级',
  WellsPE2: 'Wells PE 评分（2段）',
  WellsPE: 'Wells评分（PE）',
  CCSAngina: '心绞痛分级（CCS）',
  ABCD2: 'ABCD² 评分',
  CHA2DS2VASc: 'CHA₂DS₂-VASc评分',
  CHADS2: 'CHADS₂ 评分',
  NYHA: 'NYHA 心功能分级',
  ShockIndex: '休克指数',
  ValveAreaGorlin: '心脏瓣膜面积（Gorlin）',
  AtrialFibrillationSymptomScore: '房颤症状评分（AF）',
  BorgDyspneaScore: 'Borg呼吸困难评分',
  AcuteLowerLimbIschemia: '急性下肢缺血分级',
  BorgCR10: 'BorgCR10分级',
  WellsDVT: 'Wells评分（DVT）',
  WalkingTestDistance6: '6分钟步行测试距离',
  FraminghamCHDRisk: 'FraminghamCHD风险（ATPIII）',
  DukeDiagnosticCriteria: 'Duke诊断标准',
  GestationalHypertension: '妊娠高血压分类',
  WarfarinDose: '华法林剂量',
  PROCAMScore: 'PROCAM评分',
  DanielECG: '用于PE的DanielECG评分',
  SEPSISSIRS1: '脓毒症SIRS诊断标准',
  WARFARINELDERLY: '华法林出血风险评分-老年患者',
  VTEDASHSCORE: 'DASH预测评分',
  IFTPRC: '妊娠高血压终止妊娠的指征',
  TASCFEMORALPOPLITEAL: 'TASC分级 （胭窝动脉病变）',
  TASCAORTOILIAC: 'TASC分级（主髂动脉病变）',
  ICVDTYF: '国人缺血性心血管病（ICVD）十年发病危险度评估表-女性',
  ABCD2SCORE: 'ABCD2评分',
  BODEXINDEX: 'BODEx指数',
  PTSVILLALTASCORE: '下肢深静脉血栓后遗症（PTS）的Villalta评分',
  HFVALIANTRISKSCORE: '心衰VALIANT风险评分',
  HFMUSICRISKSCORE: '慢性心衰MUSIC危险评分',
  SAMS_CI: '他汀类药物相关肌肉症状临床指数（SAMS-CI）',
  Atrial_fibrillation: 'CHA2DS2-VASc-60评分',
  SCORE_Risk_Charts: '系统性冠状动脉风险评估量表',
  Aortic_aneurysm: '主动脉瘤Crawford分型',
  Activated_Partial_Thromboplastin_Time: '活化部分凝血活酶时间（APTT）',
  Cardiac_Troponin_I: '肌钙蛋白I（TnI）',
  Lactate_Dehydrogenase: '乳酸脱氢酶（LDH）',
  Digitoxin: '洋地黄毒苷',
  Apo_A_1: '载脂蛋白A-1',
  ApoB: '载脂蛋白B',
  LP_a: '脂蛋白(a)',
  Low_Density_Lipoprotein_Cholesterol: '低密度脂蛋白胆固醇（LDL-C）',
  Digoxin: '地高辛',
  Glycine: '甘氨酸（Gly）',
  Triglycerides: '甘油三酯（TG）',
  High_Density_Lipoprotein_Cholesterol: '高密度脂蛋白胆固醇（HDL-C）',
  Cysteine: '胱氨酸（Cys）',
  Myoglobin: '肌红蛋白（Mb）',
  N_terminal_pro_B_type_natriuretic_peptide: 'N末端B型利钠肽原（NT-proBNP）',
  N1_methylnicotinamide: 'N1-甲基烟酰胺（烟酸代谢物）',
  N_Acetylprocainamide: 'N-乙酰普鲁卡因酰胺（NAPA）',
  CK_MB_Mass: 'CK-MB质量（定量检测）',
  CK_MB_Activity: 'CK-MB（活性）',
  Salicylate: '水杨酸盐',
  Aspartate_Aminotransferase: '天冬氨酸氨基转移酶（AST/SGOT）'
}
/** 对应的描述 */
const categoryDescMap = {
  Killip: '心肌梗死危险性分级',
  WellsPE2: '肺栓塞临床可能性',
  WellsPE: '肺栓塞的临床可能性',
  CCSAngina: '加拿大心血管协会',
  ABCD2: 'TIA 后脑卒中风险',
  CHA2DS2VASc: '房颤患者脑卒中发病风险',
  CHADS2: '房颤患者脑卒中发病风险',
  NYHA: '心衰程度分级',
  HEART: '主要心脏事件风险',
  MeanArterialPressure: '根据收缩压和舒张压计算',
  ShockIndex: '休克的简易判断及死亡风险',
  ValveAreaGorlin: '导管法',
  AtrialFibrillationSymptomScore: '房颤症状严重程度评估',
  BorgDyspneaScore: '评价患者呼吸困难的程度',
  AcuteLowerLimbIschemia: '评估急性下肢缺血程度',
  BorgCR10: '描述对运动的感知',
  WellsDVT: '深静脉血栓风险评估模型',
  WalkingTestDistance6: '评估心肺疾病患者运动耐力',
  FraminghamCHDRisk: '10年冠心病风险',
  DukeDiagnosticCriteria: '诊断感染性心内膜炎',
  GestationalHypertension: '',
  WarfarinDose: '成人华法林剂量调整方案',
  PROCAMScore: '心肌梗死风险',
  DanielECG: '肺栓塞时的心脏应激',
  WARFARINELDERLY: '老年房颤患者华法林抗凝治疗出血风险评估',
  VTEDASHSCORE: '复发性静脉血栓栓塞症的预测评分',
  TASCFEMORALPOPLITEAL: '股腘动脉病变的TASCII分型',
  TASCAORTOILIAC: '主髂动脉闭塞病变的TASCII分型',
  ICVDTYF: 'ICVD事件10年发病危险预测模型和简易评估工具',
  ABCD2SCORE: 'TIA后卒中风险预测评分',
  BODEXINDEX: '慢性阻塞性肺疾病预后评估积分系统',
  PTSVILLALTASCORE: 'PTS诊断及严重程度评估系统',
  HFVALIANTRISKSCORE: '心衰预测风险评分',
  HFMUSICRISKSCORE: '心衰预后MUSIC风险评分',
  SAMS_CI: '评估药物与肌肉症状的相关性',
  Atrial_fibrillation: '房颤卒中风险评估及抗凝治疗',
  SCORE_Risk_Charts: '预估无症状人群10年内发生致死性CVD的风险'
}
/** 没有公式描述的页面 */
const categoryNotInfoMap = {}
export default {
  categoryMap,
  categoryDescMap,
  categoryNotInfoMap
}



// WEBPACK FOOTER //
// ./src/utils/category/Card.js